
import styles from './index.module.less';

import img1 from '@/assets/images/main/productInfo/1.png'
import img2 from '@/assets/images/main/productInfo/2.png'
import img3 from '@/assets/images/main/productInfo/3.png'
import img4 from '@/assets/images/main/productInfo/4.png'
import img5 from '@/assets/images/main/productInfo/5.png'

export default function ProductInfo () {
  return (
    <div className={styles.ProductInfo}>
      <img src={img1} alt="" />
      <img src={img2} alt="" />
      <img src={img3} alt="" />
      <img src={img4} alt="" />
      <img src={img5} alt="" />
    </div>
  )
}